import l from '../lang';
import { Client } from '../store/clients/interfaces';
import { countryName } from './payment-methods-utils';
import { createDate } from './index';

const escapeCsv = (value: string | number | undefined | null) => {
  const str = value == null || value === '' ? '-' : String(value);
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

const formatDate = (date?: string) => {
  if (!date) {
    return '-';
  }

  try {
    const parsed = createDate(date);
    const day = String(parsed.getDate()).padStart(2, '0');
    const month = String(parsed.getMonth() + 1).padStart(2, '0');
    const year = String(parsed.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
  } catch {
    return date;
  }
};

const formatAmount = (amount?: number, currency?: string) => {
  if (amount == null || Number.isNaN(Number(amount))) {
    return '-';
  }

  const formatted = Number(amount).toLocaleString('es-AR', {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  });

  return `${currency || ''} ${formatted}`.trim();
};

export const buildClientsCsv = (clients: Client[]) => {
  const headers = [
    l('clients.client'),
    l('clients.country'),
    l('clients.email'),
    l('clients.firstTransaction'),
    l('clients.lastTransaction'),
    l('clients.transactedAmount'),
    l('clients.status'),
    l('clients.merchantClientId'),
  ];

  const rows = clients.map(client => {
    const fullName = [client.firstName, client.lastName].filter(Boolean).join(' ').trim() || '-';
    const status = (client.status || 'NEW').toUpperCase();

    return [
      escapeCsv(fullName),
      escapeCsv(countryName(client.country) || client.country),
      escapeCsv(client.email),
      escapeCsv(formatDate(client.firstTransactionDate)),
      escapeCsv(formatDate(client.lastTransactionDate)),
      escapeCsv(formatAmount(client.transactedAmount, client.transactedCurrency || client.currency)),
      escapeCsv(l(`clients.status.${status}`)),
      escapeCsv(client.merchantClientId || client.clientId),
    ].join(',');
  });

  return `${headers.join(',')}\n${rows.join('\n')}`;
};
